
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 29.22 25.568"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.394 0H1.826A1.826 1.826 0 000 1.826v21.915a1.826 1.826 0 001.826 1.826h25.568a1.826 1.826 0 001.826-1.826V1.826A1.826 1.826 0 0027.394 0zm-1.826 21.915H3.653V10.452L13.7 16.2a1.822 1.822 0 001.812 0l10.052-5.744zm0-15.669L14.61 12.508 3.653 6.246V3.653h21.915z","fill":"#707070"}})])
          )
        }
      }
    